import { ActionSet, createActionSet } from '@futrli/shared-services';

export const SIGN_IN_INVITATION: ActionSet = createActionSet('SIGN_IN_INVITATION');
export const CONFIRM_INVITATION: ActionSet = createActionSet('CONFIRM_INVITATION');
export const COMPLETE_NEW_PASSWORD: ActionSet = createActionSet('COMPLETE_NEW_PASSWORD');
